<script lang="ts">
  import {groups, info_client} from "../../../../stores";
  import { endTabsLoading, startTabsLoading } from "../../services"
  import Tabs from "./components/Tabs.svelte"
</script>

{#if IS_SHOW_DEBUG_JSON}
  {JSON.stringify($info_client)}
{/if}

{#if $groups.length > 1}
  <Tabs 
    on:start-loading={startTabsLoading} 
    on:end-loading={endTabsLoading}
  />
{/if}